import { defineStore } from 'pinia'
import Axios from 'axios'

var token = document.getElementsByName('csrf-token')[ 0 ].getAttribute('content')
const axios = Axios.create({
  baseURL: '/api/v1',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Credentials': 'same-origin',
    'Accept': 'application/json',
    'X-CSRF-Token': token
  }
})

export const useVideoStore = defineStore('video', {
  state: () => ({
    selected_video_id: null,
    tags: [],
    videos: [],
    active_tags: []
  }),
  getters: {
    active_tag: (state) => (tag_id) => state.active_tags.find((a) => a == tag_id),
    selected_video: (state) => {
      if (state.selected_video_id == null) return null
      return state.videos.find((v) => v.id == state.selected_video_id)
    },
    selected_videos: (state) => {
      if (state.active_tags.length == 0) return state.videos
      return state.videos.filter((v) => {
        return state.active_tags.every(e => v.tags.find(v => v.id == e))
      })
    }
  },
  actions: {
    async fetchStartup() {
      const response = await axios.get('startup')
      this.tags = response.data.tags
      this.videos = response.data.videos
    },
    toggle_tag(tag_id) {
      const index = this.active_tags.indexOf(tag_id)
      if (index >= 0) {
        this.active_tags.splice(index, 1)
      } else {
        this.active_tags.push(tag_id)
      }
    },
    select_video(video_id) {
      this.selected_video_id = video_id
    }
  }
})
